import { render } from "./ass_entusrNew.vue?vue&type=template&id=06a0e281&scoped=true"
import script from "./ass_entusrNew.vue?vue&type=script&lang=js"
export * from "./ass_entusrNew.vue?vue&type=script&lang=js"

import "./ass_entusrNew.vue?vue&type=style&index=0&id=06a0e281&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a0e281"]])

export default __exports__